<template>
    <div class="row">
      <div class="col-md-12" style="margin: -15px;">
        <div class="card">
          <div class="card-header" style="background-color:  #DBECDB;">
            <h4 class="card-title">Gestión de Unidades Organizacionales</h4>
            <div class="d-flex justify-content-between align-items-center">
              <p class="card-category">Lista de unidades registrados en el sistema</p>
              <router-link 
                v-if="hasPermission('unidad_create')" 
                to="/unidad/create" 
                class="btn btn-primary btn-round"
              >
                <i class="fa fa-plus"></i> Nueva Unidad
              </router-link>
            </div>
          </div>
          <div class="card-body">
            <div v-if="loading" class="text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
            </div>
            
            <div v-else>
              <div class="table-responsive">
                <table class="table table-sm table-striped table-hover table-bordered"   >
                  <thead class="text-primary">
                    <tr style="line-height: 8px; font-size: 0.8rem;">
                      <th>Sigla</th>
                      <th>Unidad Organizacional</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="unidad in unidades" :key="unidad.id" >
                      <td>{{ unidad.codigo }}</td>
                      <td>{{ unidad.nombre_unidad }}</td>
                      <td>
                        <span 
                          :class="unidad.estado === 'activo' ? 'badge bg-success' : 'badge bg-danger'"
                        >
                          {{ unidad.estado }}
                        </span>
                      </td>
                      <td>
                        <div class="btn-group">
                          <router-link 
                            v-if="hasPermission('unidad_update')" 
                            :to="`/unidad/edit/${unidad.id}`" 
                            class="btn btn-sm btn-warning"
                          >
                            <i class="fa fa-edit"></i>
                          </router-link>
                          <button 
                            v-if="hasPermission('unidad_delete')" 
                            @click="confirmDelete(unidad)"
                            class="btn btn-sm btn-danger"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted, computed } from 'vue';
  import axios from 'axios';
  import { useAuthStore } from '../../stores/authStore';
  import Swal from 'sweetalert2';
  //import { useSwal } from 'sweetalert2';
  
  export default {
    setup() {
      const unidades = ref([]);
      const loading = ref(true);
      const authStore = useAuthStore();
      //const swal = useSwal();
      
      const currentUserId = computed(() => {
        return authStore.user?.user?.id;
      });
      
      const fetchUnidad = async () => {
        loading.value = true;
        try {
          const response = await axios.get('/unidad/list');
          unidades.value = response.data.unidades;
        } catch (error) {
          console.error('Error al cargar unidades:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudieron cargar las unidades organizacionales'
          });
        } finally {
          loading.value = false;
        }
      };
      
      const confirmDelete = (unidad) => {
        Swal.fire({
          title: '¿Está seguro?',
          text: `¿Desea eliminar al usuario ${unidad.nombre_unidad}?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            deleteUser(unidad.id);
          }
        });
      };
      
      const deleteUnidad = async (id) => {
        try {
          await axios.delete(`/unidad/delete/${id}`);
          Swal.fire({
            icon: 'success',
            title: 'Unidad eliminado',
            text: 'La Unidad ha sido eliminado correctamente'
          });
          await fetchUnidad();
        } catch (error) {
          console.error('Error al eliminar unidad:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'No se pudo eliminar la unidad'
          });
        }
      };
      
      const hasPermission = (permission) => {
        return authStore.hasPermission(permission);
      };
      
      onMounted(() => {
        fetchUnidad();
      });
      
      return {
        unidades,
        loading,
        currentUserId,
        confirmDelete,
        hasPermission
      };
    }
  };
</script>
<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
  }
  tbody td{
    margin: 0px;
    padding: 0px;
    height: 10px;
  }
</style>